/**
 * Formats a phone number for sending to the API (Twilio format)
 * Takes display format and converts to E.164 format with country code
 * @param {string} phone - Phone number in any format
 * @returns {string} - Phone number in E.164 format with country code
 */
const formatPhoneForAPI = (phone) => {
	if (!phone) return '';

	// Remove all non-numeric characters
	let cleanPhone = phone.replace(/\D/g, '');

	// Handle Australian numbers FIRST (starting with 61 or 0)
	// Check for Australian mobile numbers starting with 04
	if (
		cleanPhone.charAt(0) === '0' &&
		cleanPhone.charAt(1) === '4' &&
		cleanPhone.length === 10
	) {
		// Australian mobile number starting with 04
		cleanPhone = cleanPhone.substring(1);
		return `+61${cleanPhone}`;
	}

	// Check for Australian landline numbers starting with other 0 prefixes
	if (cleanPhone.charAt(0) === '0' && cleanPhone.length === 10) {
		// Australian landline/mobile number starting with 0
		cleanPhone = cleanPhone.substring(1);
		return `+61${cleanPhone}`;
	}

	// Check for Australian mobile numbers without leading 0 (e.g., 4XX XXX XXX)
	if (cleanPhone.charAt(0) === '4' && cleanPhone.length === 9) {
		// Australian mobile number without leading 0
		return `+61${cleanPhone}`;
	}

	if (cleanPhone.indexOf('61') === 0 && cleanPhone.length === 11) {
		// Already has country code
		return `+${cleanPhone}`;
	}

	// Handle North American numbers (US/Canada)
	// If it's 10 digits and doesn't start with 0, add the +1 prefix
	if (cleanPhone.length === 10 && cleanPhone.charAt(0) !== '0') {
		return `+1${cleanPhone}`;
	}

	// If it's 11 digits starting with 1, add the +
	if (cleanPhone.length === 11 && cleanPhone.charAt(0) === '1') {
		return `+${cleanPhone}`;
	}

	// Handle UK numbers (starting with 44 or 0)
	if (
		cleanPhone.charAt(0) === '0' &&
		cleanPhone.charAt(1) === '7' &&
		cleanPhone.length === 11
	) {
		// UK mobile number starting with 07
		cleanPhone = cleanPhone.substring(1);
		return `+44${cleanPhone}`;
	}

	if (
		cleanPhone.indexOf('44') === 0 &&
		(cleanPhone.length === 12 || cleanPhone.length === 11)
	) {
		// Already has country code
		return `+${cleanPhone}`;
	}

	// If the phone already starts with +, just return it
	if (phone.charAt(0) === '+') {
		return phone;
	}

	// Default to North American format if we can't determine
	// This handles partial numbers during typing
	if (cleanPhone.length > 0 && cleanPhone.length <= 10) {
		return `+1${cleanPhone}`;
	}

	return phone;
};

export default formatPhoneForAPI;
